import { Characteristic, CharacteristicType } from "./_types";

export const LIB_CHARS_KIWI_VINE: Characteristic[] = [
    //* Vine Phenology
    {
        id: "date_vine_bud_swell",
        type: CharacteristicType.Event,
        label: "Bud Swell",
        categoryId: "vine_phenology",
        params:{
            color: "#7E57C2",
            bbch_principal_stage: "0",
            bbch_code: "01"
        }
    },
    {
        id: "date_vine_full_bud_30",
        type: CharacteristicType.Event,
        label: "Full Budbreak > 30%",
        categoryId: "vine_phenology",
        params:{
            color: "#7E57C2",
        }
    },
    {
        id: "date_vine_leaf_tips",
        type: CharacteristicType.Event,
        label: "Leaf Tips Visible",
        categoryId: "vine_phenology",
        params: {
            color: "#7E57C2",
            bbch_principal_stage: "0",
            bbch_code: "07"
        }
    },
    {
        id: "date_vine_cluster_open",
        type: CharacteristicType.Event,
        label: "Open Cluster",
        categoryId: "vine_phenology",
        params: {
            color: "#ee8d2d",
            bbch_principal_stage: "1",
            bbch_code: "10"
        }
    },
    {
        id: "date_vine_leaf_visible",
        type: CharacteristicType.Event,
        label: "Leaves Visible",
        categoryId: "vine_phenology",
        params: {
            color: "#ee8d2d",
            bbch_principal_stage: "1",
            bbch_code: "11"
        }
    },
    {
        id: "date_vine_leaf_unfold",
        type: CharacteristicType.Event,
        label: "Leaves Unfold",
        categoryId: "vine_phenology",
        params: {
            color: "#ee8d2d",
            bbch_principal_stage: "1",
            bbch_code: "12-18"
        }
    },
    {
        id: "date_vine_10_shoot",
        type: CharacteristicType.Event,
        label: "10% Shoot Length",
        categoryId: "vine_phenology",
        params: {
            color: "#57c263",
            bbch_principal_stage: "3",
            bbch_code: "31"
        }
    },
    {
        id: "date_vine_50_shoot",
        type: CharacteristicType.Event,
        label: "50% Shoot Length",
        categoryId: "vine_phenology",
        params: {
            color: "#57c263",
            bbch_principal_stage: "3",
            bbch_code: "35"
        }
    },
    {
        id: "date_vine_90_shoot",
        type: CharacteristicType.Event,
        label: "90% Shoot Length",
        categoryId: "vine_phenology",
        params: {
            color: "#57c263",
            bbch_principal_stage: "3",
            bbch_code: "39"
        }
    },
    {
        id: "date_vine_sepals",
        type: CharacteristicType.Event,
        label: "Sepals Separate",
        categoryId: "vine_phenology",
        params: {
            color: "#dce925",
            bbch_principal_stage: "5",
            bbch_code: "55"
        }
    },
    {
        id: "date_vine_balloon",
        type: CharacteristicType.Event,
        label: "Balloon Stage",
        categoryId: "vine_phenology",
        params: {
            color: "#dce925",
            bbch_principal_stage: "5",
            bbch_code: "56-59"
        }
    },
    {
        id: "date_vine_start_flower",
        type: CharacteristicType.Event,
        label: "First Flowers Open",
        categoryId: "vine_phenology",
        params: {
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "56-59"
        }
    },
    {
        id: "date_vine_50_flower",
        type: CharacteristicType.Event,
        label: "50% Flowering",
        categoryId: "vine_phenology",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "65"
        }
    },
    {
        id: "date_vine_full_bloom_60",
        type: CharacteristicType.Event,
        label: "Full Bloom > 60%",
        categoryId: "vine_phenology",
        params:{
            color: "#FFCC80",
        }
    },
    {
        id: "date_vine_flower_end",
        type: CharacteristicType.Event,
        label: "End of Flowering",
        categoryId: "vine_phenology",
        params:{
            color: "#FFCC80",
        }
    },
    {
        id: "date_vine_petal_end",
        type: CharacteristicType.Event,
        label: "Petal Fall Ends",
        categoryId: "vine_phenology",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "68-69"
        }
    },
    {
        id: "date_vine_frut_develop",
        type: CharacteristicType.Event,
        label: "Fruit Development",
        categoryId: "vine_phenology",
        params:{
            color: "#d400bf",
            bbch_principal_stage: "7",
            bbch_code: "71-79"
        }
    },
    {
        id: "date_vine_frut_mature",
        type: CharacteristicType.Event,
        label: "Fruit Mature",
        categoryId: "vine_phenology",
        params:{
            color: "#00BCD4",
            bbch_principal_stage: "8",
            bbch_code: "81-84"
        }
    },
    {
        id: "date_vine_seeds_colour",
        type: CharacteristicType.Event,
        label: "Seed Colour Change",
        categoryId: "vine_phenology",
        params:{
            color: "#00BCD4",
            bbch_principal_stage: "8",
            bbch_code: "85"
        }
    },
    {
        id: "date_vine_seeds_black",
        type: CharacteristicType.Event,
        label: "Seeds Blacken",
        categoryId: "vine_phenology",
        params:{
            color: "#00BCD4",
            bbch_principal_stage: "8",
            bbch_code: "85"
        }
    },
    {
        id: "date_vine_full_ripe",
        type: CharacteristicType.Event,
        label: "Fully Ripe",
        categoryId: "vine_phenology",
        params:{
            color: "#00BCD4",
            bbch_principal_stage: "8",
            bbch_code: "89"
        }
    },
    {
        id: "date_vine_leaf_drop",
        type: CharacteristicType.Event,
        label: "Initial Leaf Drop",
        categoryId: "vine_phenology",
        params:{
            color: "#43A047",
            bbch_principal_stage: "9",
            bbch_code: "93-96"
        }
    },
    {
        id: "date_vine_leaf_drop_end",
        type: CharacteristicType.Event,
        label: "Leaf Drop Ends",
        categoryId: "vine_phenology",
        params:{
            color: "#43A047",
            bbch_principal_stage: "9",
            bbch_code: "97"
        }
    },

    //* Vine Male Characteristics
    {
        id: "date_male_bud_swell",
        type: CharacteristicType.Event,
        label: "Bud Swell",
        categoryId: "vine_male",
        params:{
            color: "#7E57C2",
            bbch_principal_stage: "0",
            bbch_code: "01"
        }
    },
    {
        id: "date_male_balloon",
        type: CharacteristicType.Event,
        label: "Balloon Stage",
        categoryId: "vine_male",
        params: {
            color: "#dce925",
            bbch_principal_stage: "5",
            bbch_code: "56-59"
        }
    },
    {
        id: "date_male_bud_burst",
        type: CharacteristicType.Event,
        label: "Bud Burst Start",
        categoryId: "vine_male",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "0",
            bbch_code: "07"
        }
    },
    {
        id: "date_male_start_flower",
        type: CharacteristicType.Event,
        label: "First Flowers Open",
        categoryId: "vine_male",
        params: {
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "56-59"
        }
    },
    {
        id: "date_male_10_flower",
        type: CharacteristicType.Event,
        label: "10% Flowering",
        categoryId: "vine_male",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "61"
        }
    },
    {
        id: "date_male_50_flower",
        type: CharacteristicType.Event,
        label: "50% Flowering",
        categoryId: "vine_male",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "65"
        }
    },
    {
        id: "date_male_full_bloom",
        type: CharacteristicType.Event,
        label: "Natural Male Full Bloom",
        categoryId: "vine_male",
        params:{
            color: "#FFCC80",
        }
    },
    {
        id: "date_male_petal_end",
        type: CharacteristicType.Event,
        label: "Petal Fall Ends",
        categoryId: "vine_male",
        params:{
            color: "#FFCC80",
            bbch_principal_stage: "6",
            bbch_code: "68-69"
        }
    },
    {
        id: "vine_male_pollen_qual",
        type: CharacteristicType.Interval,
        label: "Pollen Quality",
        categoryId: "vine_male",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very low",
                "Low",
                "Intermediate",
                "High",
                "Excellent"
            ]
        }
    },
    {
        id: "vine_male_pollen_quant",
        type: CharacteristicType.Interval,
        label: "Pollen Quantity",
        categoryId: "vine_male",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Few",
                "Moderate",
                "Plenty",
                "Abundant"
            ]
        }
    },
    {
        id: "vine_male_stamen_quant",
        type: CharacteristicType.Interval,
        label: "Stamen Quantity",
        categoryId: "vine_male",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Few",
                "Moderate",
                "Plenty",
                "Abundant"
            ]
        }
    },
    {
        id: "vine_male_pre_disease_stat",
        type: CharacteristicType.Interval,
        label: "Psa Preharvest Disease Resistance",
        categoryId: "vine_male",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Susceptible",
                "Moderately susceptible",
                "Intermediate",
                "Resistant",
                "Highly resistant"
            ]
        }
    },

    //* Vine Harvest Characterisitcs - (current category does not refelect this)
    {
        id: "vine_harv_ready_seed",
        type: CharacteristicType.Interval,
        label: "Harvest Readiness on Seed Colour/Maturity",
        categoryId: "vine_bear",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Extremely low",
                "Low",
                "Optimal",
                "High",
                "Extremely high",
            ]
        }
    },


    //* Vine Thinning
    {
        id: "vine_thin_technique",
        type: CharacteristicType.Nominal,
        categoryId: "vine_thinning",
        label: "Thinning Technique",
        params: {
            options: [
                { value: "bud_thin", label: "Bud Thinning" },
                { value: "flower_thin", label: "Flower Thinning" },
                { value: "fruit_thin", label: "Fruit Thinning" },
                { value: "shoot_thin", label: "Shoot Thinning" },
                { value: "leaf_remove", label: "Leaf Removal" },
            ]
        }
    },
    {
        id: "date_vine_thin",
        type: CharacteristicType.Event,
        label: "Thinning Date",
        categoryId: "vine_thinning",
        params:{
            color: "#00BCD4",
        }
    },
    {
        id: "vine_thin_cycles",
        type: CharacteristicType.Nominal,
        categoryId: "vine_thinning",
        label: "Thinning Cycles",
        params: {
            options: [
                { value: "thin_1", label: "1" },
                { value: "thin_2", label: "2" },
                { value: "thin_3", label: "3" },
                { value: "thin_4", label: "4" },
                { value: "thin_more", label: "5+" }
            ]
        }
    },
    {
        id: "vine_thin_application",
        type: CharacteristicType.Nominal,
        categoryId: "vine_thinning",
        label: "Thinning Application",
        params: {
            options: [
                { value: "mechanical", label: "Mechanical Thinning" },
                { value: "hand", label: "Hand Thinning" },
                { value: "chemical", label: "Chemical Thinning" },
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_thin_level",
        type: CharacteristicType.Interval,
        label: "Thinning Level",
        categoryId: "vine_thinning",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "Negligible to none",
                "Light",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_thin_stage",
        type: CharacteristicType.Nominal,
        categoryId: "vine_thinning",
        label: "Phenological Stage When Thinning",
        params: {
            options: [
                { value: "bud_swell", label: "Bud Swell" },
                { value: "bud_burst_start", label: "Bud Burst Start" },
                { value: "leaf_tips", label: "Leaf Tips Visible" },
                { value: "open_cluster", label: "Open Cluster" },
                { value: "leaf_visible", label: "Leaves Visible" },
                { value: "leaf_unfold", label: "Leaves Unfold" },
                { value: "10_shoot", label: "10% Shoot Length" },
                { value: "50_shoot", label: "50% Shoot Length" },
                { value: "90_shoot", label: "90% Shoot Length" },
                { value: "sepals_separate", label: "Sepals Separate" },
                { value: "balloon_stage", label: "Balloon Stage" },
                { value: "first_flowers", label: "First Flowers Open" },
                { value: "10_flower", label: "10% Flowering" },
                { value: "50_flower", label: "50% Flowering" },
                { value: "petals_ends", label: "Petal Fall Ends" },
                { value: "fruit_development", label: "Fruit Development" },
                { value: "fruit_mature", label: "Fruit Mature" },
                { value: "seeds_colour", label: "Seed Colour Change" },
                { value: "seeds_blacken", label: "Seeds Blacken" },
                { value: "fully_ripe", label: "Fully Ripe" },
                { value: "leaf_drop", label: "Initial Leaf Drop" },
                { value: "leaf_drop_ends", label: "Leaf Drop Ends" },
            ]
        }
    },

    //* Vine Pruning
    {
        id: "vine_prune_technique",
        type: CharacteristicType.Nominal,
        categoryId: "vine_pruning",
        label: "Pruning Technique",
        params: {
            options: [
                { value: "heading_back", label: "Heading back" },
                { value: "topping", label: "Topping" },
                { value: "renewal", label: "Renewal pruning" },
                { value: "sanitation", label: "Sanitation pruning" },
                { value: "thinning", label: "Thinning" },
                { value: "summer", label: "Summer pruning, mostly done at BCH stages 18–19" },
                { value: "tip", label: "Tip pruning" },
                { value: "winter", label: "Winter pruning, mostly performed when all leaves have fallen (BBCH97)" },
                { value: "root", label: "Root pruning" },
                { value: "leaf", label: "Leaf pruning" },
                { value: "corrective", label: "Corrective pruning" },

            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_prune_level",
        type: CharacteristicType.Interval,
        label: "Pruning Level",
        categoryId: "vine_pruning",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "Negligible to none",
                "Light",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_prune_cycles",
        type: CharacteristicType.Nominal,
        categoryId: "vine_pruning",
        label: "Pruning Cycles",
        params: {
            options: [
                { value: "prune_1", label: "1" },
                { value: "prune_2", label: "2" },
                { value: "prune_3", label: "3" },
                { value: "prune_4", label: "4" },
                { value: "prune_more", label: "5+" }
            ]
        }
    },
    {
        id: "vine_prune_objective",
        type: CharacteristicType.Nominal,
        categoryId: "vine_pruning",
        label: "Pruning Objective",
        params: {
            options: [
                { value: "canopy_management", label: "Canopy management" },
                { value: "vigour_control", label: "Vigour control" },
                { value: "load_management", label: "Crop load management" },
                { value: "growth_redirection", label: "Growth redirection" },
                { value: "disease_pest", label: "Disease and pest management" },
                { value: "growth_renewal", label: "Growth renewal " },
                { value: "training", label: "Training " },
            ]
        }
    },
    {
        id: "vine_prune_stage",
        type: CharacteristicType.Nominal,
        categoryId: "vine_pruning",
        label: "Phenological Stage When Pruning",
        params: {
            options: [
                { value: "bud_swell", label: "Bud Swell" },
                { value: "bud_burst_start", label: "Bud Burst Start" },
                { value: "leaf_tips", label: "Leaf Tips Visible" },
                { value: "open_cluster", label: "Open Cluster" },
                { value: "leaf_visible", label: "Leaves Visible" },
                { value: "leaf_unfold", label: "Leaves Unfold" },
                { value: "10_shoot", label: "10% Shoot Length" },
                { value: "50_shoot", label: "50% Shoot Length" },
                { value: "90_shoot", label: "90% Shoot Length" },
                { value: "sepals_separate", label: "Sepals Separate" },
                { value: "balloon_stage", label: "Balloon Stage" },
                { value: "first_flowers", label: "First Flowers Open" },
                { value: "10_flower", label: "10% Flowering" },
                { value: "50_flower", label: "50% Flowering" },
                { value: "petals_ends", label: "Petal Fall Ends" },
                { value: "fruit_development", label: "Fruit Development" },
                { value: "fruit_mature", label: "Fruit Mature" },
                { value: "seeds_colour", label: "Seed Colour Change" },
                { value: "seeds_blacken", label: "Seeds Blacken" },
                { value: "fully_ripe", label: "Fully Ripe" },
                { value: "leaf_drop", label: "Initial Leaf Drop" },
                { value: "leaf_drop_ends", label: "Leaf Drop Ends" },
            ]
        }
    },

    //* Vine Girdling
    {
        id: "vine_girdling_technique",
        type: CharacteristicType.Nominal,
        categoryId: "vine_girdling",
        label: "Girdling Technique",
        params: {
            options: [
                { value: "trunk", label: "Trunk girdling" },
                { value: "cane", label: "Cane girdling" },
                { value: "root", label: "Root girdling" },
                { value: "stem", label: "Stem girdling" },
            ]
        }
    },
    {
        id: "date_vine_girdling",
        type: CharacteristicType.Event,
        label: "Girdling Date",
        categoryId: "vine_girdling",
        params:{
            color: "#00BCD4",
        }
    },
    {
        id: "vine_girdling_objective",
        type: CharacteristicType.Nominal,
        categoryId: "vine_girdling",
        label: "Girdling Objective",
        params: {
            options: [
                { value: "inhibit_growth", label: "Inhibit growth" },
                { value: "increase_frut_size", label: "Increase fruit size" },
                { value: "increase_dry_matter", label: "Increase dry matter" },
                { value: "prevent_infection_spread", label: "Prevent the spreading of infections" },
            ]
        }
    },
    {
        id: "vine_girdling_cycles",
        type: CharacteristicType.Nominal,
        categoryId: "vine_girdling",
        label: "Girdling Cycles",
        params: {
            options: [
                { value: "girdling_1", label: "1" },
                { value: "girdling_2", label: "2" },
                { value: "girdling_3", label: "3" },
                { value: "girdling_4", label: "4" },
                { value: "girdling_more", label: "5+" }
            ]
        }
    },
    {
        id: "vine_girdling_method",
        type: CharacteristicType.Nominal,
        categoryId: "vine_girdling",
        label: "Girdling Method",
        params: {
            options: [
                { value: "hand", label: "Hand girdling" },
                { value: "chain", label: "Chain girdling" },
                { value: "other", label: "Other methods" },
            ]
        }
    },
    {
        id: "vine_girdling_stage",
        type: CharacteristicType.Nominal,
        categoryId: "vine_girdling",
        label: "Phenological Stage When Girdling",
        params: {
            options: [
                { value: "bud_swell", label: "Bud Swell" },
                { value: "bud_burst_start", label: "Bud Burst Start" },
                { value: "leaf_tips", label: "Leaf Tips Visible" },
                { value: "open_cluster", label: "Open Cluster" },
                { value: "leaf_visible", label: "Leaves Visible" },
                { value: "leaf_unfold", label: "Leaves Unfold" },
                { value: "10_shoot", label: "10% Shoot Length" },
                { value: "50_shoot", label: "50% Shoot Length" },
                { value: "90_shoot", label: "90% Shoot Length" },
                { value: "sepals_separate", label: "Sepals Separate" },
                { value: "balloon_stage", label: "Balloon Stage" },
                { value: "first_flowers", label: "First Flowers Open" },
                { value: "10_flower", label: "10% Flowering" },
                { value: "50_flower", label: "50% Flowering" },
                { value: "petals_ends", label: "Petal Fall Ends" },
                { value: "fruit_development", label: "Fruit Development" },
                { value: "fruit_mature", label: "Fruit Mature" },
                { value: "seeds_colour", label: "Seed Colour Change" },
                { value: "seeds_blacken", label: "Seeds Blacken" },
                { value: "fully_ripe", label: "Fully Ripe" },
                { value: "leaf_drop", label: "Initial Leaf Drop" },
                { value: "leaf_drop_ends", label: "Leaf Drop Ends" },
            ]
        }
    },

    //* Vine Spraying
    {
        id: "vine_spray_content",
        type: CharacteristicType.Nominal,
        categoryId: "vine_spraying",
        label: "Chemical Spray Content ",
        params: {
            options: [
                { value: "abscisic_acid", label: "Abscisic acid colour spray" },
                { value: "bactericides", label: "Bactericides" },
                { value: "calcium_sprays", label: "Calcium sprays" },
                { value: "dormant_oils", label: "Dormant oils" },
                { value: "foliar_nutrient", label: "Foliar nutrient spray" },
                { value: "fruit_enlargement", label: "Fruit-enlargement spray" },
                { value: "fungicides", label: "Fungicides" },
                { value: "copper_based_fungicide", label: "Copper-based fungicide sprays" },
                { value: "herbicides", label: "Herbicides" },
                { value: "insecticides", label: "Insecticides" },
                { value: "rest_breaking", label: "Rest-breaking application" },
                { value: "rodenticides", label: "Rodenticides" },
            ]
        }
    },
    {
        id: "date_vine_spray",
        type: CharacteristicType.Event,
        label: "Chemical Spray Date",
        categoryId: "vine_spraying",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_spray_stage",
        type: CharacteristicType.Nominal,
        categoryId: "vine_spraying",
        label: "Phenological Stage When Spraying",
        params: {
            options: [
                { value: "bud_swell", label: "Bud Swell" },
                { value: "bud_burst_start", label: "Bud Burst Start" },
                { value: "leaf_tips", label: "Leaf Tips Visible" },
                { value: "open_cluster", label: "Open Cluster" },
                { value: "leaf_visible", label: "Leaves Visible" },
                { value: "leaf_unfold", label: "Leaves Unfold" },
                { value: "10_shoot", label: "10% Shoot Length" },
                { value: "50_shoot", label: "50% Shoot Length" },
                { value: "90_shoot", label: "90% Shoot Length" },
                { value: "sepals_separate", label: "Sepals Separate" },
                { value: "balloon_stage", label: "Balloon Stage" },
                { value: "first_flowers", label: "First Flowers Open" },
                { value: "10_flower", label: "10% Flowering" },
                { value: "50_flower", label: "50% Flowering" },
                { value: "petals_ends", label: "Petal Fall Ends" },
                { value: "fruit_development", label: "Fruit Development" },
                { value: "fruit_mature", label: "Fruit Mature" },
                { value: "seeds_colour", label: "Seed Colour Change" },
                { value: "seeds_blacken", label: "Seeds Blacken" },
                { value: "fully_ripe", label: "Fully Ripe" },
                { value: "leaf_drop", label: "Initial Leaf Drop" },
                { value: "leaf_drop_ends", label: "Leaf Drop Ends" },
            ]
        }
    },
    {
        id: "vine_spray_cycles",
        type: CharacteristicType.Nominal,
        categoryId: "vine_spraying",
        label: "Spray Cycles",
        params: {
            options: [
                { value: "spray_1", label: "1" },
                { value: "spray_2", label: "2" },
                { value: "spray_3", label: "3" },
                { value: "spray_4", label: "4" },
                { value: "spray_more", label: "5+" }
            ]
        }
    },

    //* Vine Assisted Pollination
    {
        id: "vine_pollin_technique",
        type: CharacteristicType.Nominal,
        categoryId: "vine_assisted_pollin",
        label: "Assisted Pollination Technique",
        params: {
            options: [
                { value: "natural",    label: "Natural pollination" },
                { value: "bee_hive",   label: "Bee hive introduction" },
                { value: "hand",       label: "Hand pollination" },
                { value: "mechanical", label: "Mechanical pollination" },
                { value: "combined",   label: "Combined systems" },
            ]
        }
    },
    {
        id: "date_vine_assisted_pollin",
        type: CharacteristicType.Event,
        label: "Assisted Pollination Date",
        categoryId: "vine_assisted_pollin",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_assisted_pollin_stage",
        type: CharacteristicType.Nominal,
        categoryId: "vine_assisted_pollin",
        label: "Phenological Stage of Assisted Pollination",
        params: {
            options: [
                { value: "bbch_61",  label: "BBCH 61" },
                { value: "bbch_63",  label: "BBCH 63" },
                { value: "bbch_65",  label: "BBCH 65" },
                { value: "bbch_67",  label: "BBCH 67" },
                { value: "bbch_69",  label: "BBCH 69" },
            ]
        }
    },

    //* Vine Root-Specific Characteristics
    {
        id: "vine_root_depth",
        type: CharacteristicType.Interval,
        label: "Root Depth",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Extremely shallow",
                "Shallow",
                "Intermediate",
                "Deep",
                "Extremely deep"
            ]
        }
    },
    {
        id: "vine_root_density",
        type: CharacteristicType.Interval,
        label: "Root Density and Distribution",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible",
                "Low density",
                "Intermediate",
                "Dense",
                "Very dense"
            ]
        }
    },
    {
        id: "vine_root_config",
        type: CharacteristicType.Interval,
        label: "Root Configuration",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Shallow and limited",
                "Deeper and more extensive",
                "Intermediate",
                "Vast and deep",
                "Very vast and deep"
            ]
        }
    },
    {
        id: "vine_root_suckering",
        type: CharacteristicType.Interval,
        label: "Root Suckering Tendency",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Vigorous",
                "Prolific",
                "Moderate",
                "Sparse",
                "Very sparse"
            ]
        }
    },
    {
        id: "vine_root_propagation_ease",
        type: CharacteristicType.Interval,
        label: "Ease of Propagation",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very difficult",
                "Difficult",
                "Intermediate",
                "Easy",
                "Very easy"
            ]
        }
    },
    {
        id: "vine_root_in_vitro",
        type: CharacteristicType.Interval,
        label: "In Vitro Propagation Success",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Intermediate",
                "High",
                "Extremely high"
            ]
        }
    },
    {
        id: "vine_root_compatibility",
        type: CharacteristicType.Interval,
        label: "Rootstock Compatibility",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Extremely poor",
                "Poor",
                "Intermediate",
                "Good",
                "Excellent"
            ]
        }
    },
    {
        id: "vine_root_synchronisation",
        type: CharacteristicType.Interval,
        label: "Synchronisation",
        categoryId: "vine_root_chars",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Intermediate",
                "High",
                "Extremely high"
            ]
        }
    },

    //* Vine Architecture
    {
        id: "vine_growth_habit",
        type: CharacteristicType.Nominal,
        categoryId: "vine_arch",
        label: "Growth Habit",
        params: {
            options: [
                { value: "open_spreading",  label: "Open and spreading" },
                { value: "intermediate",  label: "Intermediate growth" },
                { value: "compact_upright",  label: "Compact and upright" },
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_growth_potent_vigour",
        type: CharacteristicType.Interval,
        categoryId: "vine_arch",
        label: "Growth Potential and Vigour",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "Very weak",
                "Weak",
                "Optimal",
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_growth_canopy_dense",
        type: CharacteristicType.Interval,
        categoryId: "vine_arch",
        label: "Canopy Density",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "Very sparse",
                "Sparse",
                "Optimal",
            ]
        }
    },

    //* Vine Leaf Characteristics
    {
        id: "vine_leaf_colour",
        type: CharacteristicType.Nominal,
        categoryId: "vine_leaf",
        label: "Leaf Colour",
        params: {
            options: [
                { value: "light_green",  label: "Light Green" },
                { value: "medium_green", label: "Medium Green" },
                { value: "dark_green",   label: "Dark Green" },
                { value: "red",          label: "Red" },
                { value: "red_green",    label: "Red-green" },
                { value: "pink_green",   label: "Pink-green" },
                { value: "yellow_green", label: "Yellow-green" },
                { value: "grey_green",   label: "Grey-green" },
                { value: "other",        label: "Other" },
            ]
        }
    },
    {
        id: "vine_leaf_chroma",
        type: CharacteristicType.Interval,
        label: "Leaf Chroma",
        categoryId: "vine_leaf",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very dull",
                "Dull",
                "Moderate",
                "Vivid",
                "Bright"
            ]
        }
    },
    {
        id: "vine_leaf_intensity",
        type: CharacteristicType.Interval,
        label: "Leaf Intensity",
        categoryId: "vine_leaf",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very light",
                "Light",
                "Moderate",
                "Intense",
                "Very intense"
            ]
        }
    },
    {
        id: "vine_leaf_pubescence",
        type: CharacteristicType.Nominal,
        categoryId: "vine_leaf",
        label: "Pubescence",
        params: {
            options: [
                { value: "smooth",     label: "Smoot" },
                { value: "fine_hair",  label: "Fine, short hair" },
                { value: "very_hairy", label: "Very hairy" },
            ]
        }
    },

    //* Vine Flowering
    {
        id: "vine_flower_even_budbreak",
        type: CharacteristicType.Interval,
        label: "Flowering: Evenness of Budbreak",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
                "High",
                "Very high"
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_flower_repro_potent",
        type: CharacteristicType.Interval,
        label: "Reproductive Potential: Complete-bud-to-leaf-bud ratio",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
            ]
        }
    },

    // TODO REFACTOR BI-POLAR
    {
        id: "vine_flower_per_bud",
        type: CharacteristicType.Interval,
        label: "Flowers per Bud",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_flower_king",
        type: CharacteristicType.Interval,
        label: "King Flower ",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_flower_triples",
        type: CharacteristicType.Interval,
        label: "Triples",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_flower_quality",
        type: CharacteristicType.Interval,
        label: "Flower Quality Ratio",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Intermediate",
                "High",
                "Extremely high"
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_flower_dense",
        type: CharacteristicType.Interval,
        label: "Flower Density",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_flower_position",
        type: CharacteristicType.Nominal,
        label: "Flower position",
        categoryId: "vine_flower",
        params: {
            options: [
                { value: "base",        label: "Base flowers" },
                { value: "middle",      label: "Middle flowers" },
                { value: "tip",         label: "Tip flowers" },
                { value: "whole_cane",  label: "Whole cane" },
            ]
        }
    },
    {
        id: "vine_flower_rba",
        type: CharacteristicType.Nominal,
        label: "Rest-Breaking Agent (RBA)",
        categoryId: "vine_flower",
        params: {
            options: [
                { value: "hydrogen_cyanamide",  label: "Hydrogen Cyanamide" },
            ]
        }
    },
    {
        id: "vine_flower_rba_date",
        type: CharacteristicType.Event,
        label: "RBA Application Date",
        categoryId: "vine_flower",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_flower_rba_rate",
        type: CharacteristicType.Interval,
        label: "RBA Application Rate",
        categoryId: "vine_flower",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very low",
                "Low",
                "Moderate",
                "High",
                "Very High"
            ]
        }
    },

    //* Vine Flower Termination and Disorders
    {
        id: "vine_flower_abnormal",
        type: CharacteristicType.Nominal,
        categoryId: "vine_flower_disorder",
        label: "Number of Flowering Events",
        params: {
            options: [
                { value: "flushes_1", label: "1" },
                { value: "flushes_2", label: "2" },
                { value: "flushes_3", label: "3" },
                { value: "flushes_4", label: "4" },
                { value: "flushes_more", label: "5+" }
            ]
        }
    },
    {
        id: "vine_abnormal_fruit_ratio",
        type: CharacteristicType.Interval,
        label: "Preharvest Normal-to-Aberrant Fruit Ratio",
        categoryId: "vine_flower_disorder",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very low",
                "Low",
                "Moderate",
                "High",
                "Very High"
            ]
        }
    },

    //* Pre-Harvest Crop monitoring
    {
        id: "vine_unform_ripe_harv",
        type: CharacteristicType.Interval,
        label: "Uniformity of Ripening at Harvest",
        categoryId: "vine_crop_monitor",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very uneven",
                "Uneven",
                "Intermediate",
                "Even",
                "Highly uniform"
            ]
        }
    },
    {
        id: "vine_stalk_size",
        type: CharacteristicType.Nominal,
        label: "Fruit stalk size",
        categoryId: "vine_crop_monitor",
        params: {
            options: [
                { value: "small",   label: "Small" },
                { value: "medium",  label: "Medium" },
                { value: "large",   label: "Large" },
            ]
        }
    },
    {
        id: "vine_seed_colour",
        type: CharacteristicType.Nominal,
        label: "Seed Colour",
        categoryId: "vine_crop_monitor",
        params: {
            options: [
                { value: "white_small",     label: "White and small" },
                { value: "white_full",      label: "White and full-size" },
                { value: "light_brown",     label: "Light brown" },
                { value: "dark_brown",      label: "Dark brown" },
                { value: "black",           label: "Black" },
            ]
        }
    },

    //* Vine Bearing Characteristics
    {
        id: "vine_pollin_effi",
        type: CharacteristicType.Interval,
        label: "Pollination Efficiency",
        categoryId: "vine_bearing",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Intermediate",
                "High",
                "Excellent"
            ]
        }
    },

    //* Vine Bearing Disorders
    {
        id: "vine_alt_bearing",
        type: CharacteristicType.Interval,
        label: "Alternate Bearing",
        categoryId: "vine_bear_disorder",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly alternating",
                "Alternating",
                "Intermediate",
                "Consistent",
                "Very consistent"
            ]
        }
    },
    {
        id: "vine_preharv_drop",
        type: CharacteristicType.Interval,
        label: "Preharvest Drop",
        categoryId: "vine_bear_disorder",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },

    //* Vine Preharvest Pests
    {
        id: "vine_preharv_pest_vine",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_pests",
        label: "Preharvest Vine-pests",
        params: {
            options: [
                { value: "leaf_rollers",    label: "Brown and green-headed leaf rollers" },
                { value: "brown_stink_bug", label: "Brown marmorated stink bugs" },
                { value: "fruit_flies",     label: "Fruit flies" },
                { value: "passion_hooper",  label: "Passion vine hopper" },
                { value: "scale_insects",   label: "Scale insects" },
                { value: "thrips",          label: "Thrips" },
            ]
        }
    },
    {
        id: "vine_preharv_pest_root",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_pests",
        label: "Preharvest Rootstock-specific pests",
        params: {
            options: [
                { value: "black_vine_weevil",   label: "Black Vine Weevil" },
                { value: "citrus_longhorn",     label: "Citrus Longhorn Beetle Larvae" },
                { value: "curl_grubs",          label: "Curl Grubs" },
                { value: "dagger_nematodes",    label: "Dagger Nematodes" },
                { value: "phytomonas_rot",      label: "Phytomonas Root Rot" },
                { value: "aphids",              label: "Root Aphids" },
                { value: "nematodes",           label: "Root Lesion Nematodes" },
                { value: "weevils",             label: "Root Weevils" },
                { value: "feed_beetle",         label: "Root-Feeding Beetle" },
                { value: "feed_caterpillas",    label: "Root-Feeding Caterpillars" },
                { value: "stem_bulb_nemstodes", label: "Stem and Bulb Nematodes" },
                { value: "white_grubs",         label: "White Grubs" },
                { value: "wireworm",            label: "Wireworm" },
            ]
        }
    },
    {
        id: "vine_pre_pest_prev",
        type: CharacteristicType.Interval,
        label: "Pest Prevalence",
        categoryId: "vine_preharv_pests",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_pre_pest_sever",
        type: CharacteristicType.Interval,
        label: "Pest Severity",
        categoryId: "vine_preharv_pests",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Inconspicuous to none",
                "Conspicuous",
                "Moderate",
                "Substantial",
                "Severe"
            ]
        }
    },

    //* Vine Preharvest Diseases
    {
        id: "vine_pre_disease_stat",
        type: CharacteristicType.Interval,
        label: "Psa Preharvest Disease Resistance",
        categoryId: "vine_preharv_disease",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Susceptible",
                "Moderately susceptible",
                "Intermediate",
                "Resistant",
                "Highly resistant"
            ]
        }
    },
    {
        id: "vine_preharv_disease_vine",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_disease",
        label: "Preharvest Vine Diseases",
        params: {
            options: [
                { value: "anthracnose",         label: "Anthracnose" },
                { value: "armillaria_rot",      label: "Armillaria Root Rot" },
                { value: "rhizoctonia_rot",     label: "Rhizoctonia Root Rot" },
                { value: "bacterial_canker",    label: "Bacterial Canker" },
                { value: "bacterial_leaf_spot", label: "Bacterial leaf spot and blossom blight" },
                { value: "black_rot",           label: "Black Root Rot" },
                { value: "collar_rot",          label: "Collar rot" },
                { value: "crown_rot",           label: "Crown rot" },
                { value: "fungal_leaf_spot",    label: "Fungal leaf spot" },
                { value: "fusarium_rot",        label: "Fusarium root rot" },
                { value: "cylindrocarpon_rot",  label: "Cylindrocarpon Root Rot" },
                { value: "grey_mould",          label: "Grey Mould" },
                { value: "leader_die",          label: "Leader die-back" },
                { value: "psa",                 label: "PSA" },
                { value: "pythium_rot",         label: "Pythium root rot" },
                { value: "root_rot",            label: "Root rot" },
                { value: "sclerotinia_rot",     label: "Sclerotinia rot" },
                { value: "verticillium_wilt",   label: "Verticillium wilt" },
            ]
        }
    },
    {
        id: "vine_preharv_disease_root",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_disease",
        label: "Preharvest Root-Specific Diseases",
        params: {
            options: [
                { value: "soft_rot",                    label: "Soft rot" },
                { value: "collar_rot",                  label: "Collar rot" },
                { value: "stem_end_rot",                label: "Stem-end rot" },
                { value: "phytophthora_rot",            label: "Phytophthora Root Rot" },
                { value: "armillaria_rot",              label: "Armillaria Root Rot" },
                { value: "verticillium_wilt",           label: "Verticillium wilt" },
                { value: "pseudomonas_syringae",        label: "Pseudomonas syringae" },
                { value: "pseudomonas_viridiflava",     label: "Pseudomonas viridiflava causing bacterial blight" },
                { value: "phytophthora",                label: "Phytophthora" },
                { value: "replant_disease",             label: "Replant Disease" },
                { value: "general_root_rot",            label: "General Root Rot Fungi Susceptibility" },
            ]
        }
    },
    {
        id: "date_vine_preharv_disease",
        type: CharacteristicType.Event,
        label: "Preharvest Disease Infection Date",
        categoryId: "vine_preharv_disease",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_pre_disease_prev",
        type: CharacteristicType.Interval,
        label: "Preharvest Disease Prevalence",
        categoryId: "vine_preharv_disease",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_pre_disease_sever",
        type: CharacteristicType.Interval,
        label: "Preharvest Disease Severity",
        categoryId: "vine_preharv_disease",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Inconspicuous to none",
                "Conspicuous",
                "Moderate",
                "Substantial",
                "Severe"
            ]
        }
    },

    //* Vine Preharvest Defects and Disorders
    {
        id: "vine_preharv_defect_ident",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_defect",
        label: "Preharvest Defect Identification",
        params: {
            options: [
                { value: "deformed_fruit",          label: "Misshapen and deformed fruit" },
                { value: "blemishes",               label: "Blemishes" },
                { value: "fruit_cracking",          label: "Fruit cracking" },
                { value: "physiological_cracking",  label: "Physiological cracking" },
                { value: "russeting",               label: "Russeting" },
                { value: "shrivelling",             label: "Shrivelling" },
                { value: "sunburn",                 label: "Sunburn" },
                { value: "wind_rub",                label: "Wind rub" },
            ]
        }
    },
    {
        id: "vine_pre_defect_prev",
        type: CharacteristicType.Interval,
        label: "Preharvest Defect Prevalence",
        categoryId: "vine_preharv_defect",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_pre_defect_sever",
        type: CharacteristicType.Interval,
        label: "Preharvest Defect Severity",
        categoryId: "vine_preharv_defect",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Inconspicuous to none",
                "Conspicuous",
                "Moderate",
                "Substantial",
                "Severe"
            ]
        }
    },
    {
        id: "vine_preharv_disorder_ident",
        type: CharacteristicType.Nominal,
        categoryId: "vine_preharv_defect",
        label: "Preharvest Disorder Identification",
        params: {
            options: [
                { value: "calcium_deficiency",      label: "Calcium deficiency" },
                { value: "deformed_fruit",          label: "Deformed fruit" },
                { value: "iron_deficiency",         label: "Iron deficiency" },
                { value: "magnesium_deficiency",    label: "Magnesium deficiency" },
                { value: "potassium_deficiency",    label: "Potassium deficiency" },
                { value: "waterlogging",            label: "Waterlogging" },
            ]
        }
    },
    {
        id: "vine_pre_disorder_prev",
        type: CharacteristicType.Interval,
        label: "Preharvest Disorder Prevalence",
        categoryId: "vine_preharv_defect",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_pre_disorder_sever",
        type: CharacteristicType.Interval,
        label: "Preharvest Disorder Severity",
        categoryId: "vine_preharv_defect",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Inconspicuous to none",
                "Conspicuous",
                "Moderate",
                "Substantial",
                "Severe"
            ]
        }
    },

    //* Reaction To Preharvest Abiotic Stress Factors
    {
        id: "vine_physical_dmg_ident",
        type: CharacteristicType.Nominal,
        categoryId: "vine_abiotic_stress",
        label: "Preharvest Physical Damage Identification",
        params: {
            options: [
                { value: "abrasions",       label: "Abrasions" },
                { value: "bruises_wounds",  label: "Bruises and wounds" },
                { value: "blemishes",  label: "Blemishes" },
            ]
        }
    },
    {
        id: "date_vine_physical_dmg",
        type: CharacteristicType.Event,
        label: "Preharvest Physical Damage Date",
        categoryId: "vine_abiotic_stress",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_physical_dmg_tolerance",
        type: CharacteristicType.Interval,
        label: "Preharvest Physical Damage Tolerance",
        categoryId: "vine_abiotic_stress",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly susceptible",
                "Susceptible",
                "Moderate",
                "Resistant",
                "Highly resistant"
            ]
        }
    },
    {
        id: "vine_abiotic_ident",
        type: CharacteristicType.Nominal,
        categoryId: "vine_abiotic_stress",
        label: "Preharvest Abiotic Stress Identification",
        params: {
            options: [
                { value: "waterlogging_tol",    label: "Waterlogging tolerance" },
                { value: "acid_soil_tol",       label: "Acidic soil tolerance" },
                { value: "cold_tol",            label: "Cold tolerance" },
                { value: "drought_tol",         label: "Drought tolerance" },
                { value: "freezing_tol",        label: "Freezing tolerance" },
                { value: "heat_tol",            label: "Heat tolerance" },
                { value: "sun_tol",             label: "Sun tolerance" },
                { value: "salt_tol",            label: "Salt tolerance" },
                { value: "wind_tol",            label: "Wind tolerance" },
            ]
        }
    },
    {
        id: "date_vine_abiotic_stress",
        type: CharacteristicType.Event,
        label: "Preharvest Abiotic Damage Date",
        categoryId: "vine_abiotic_stress",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_abiotic_dmg_level",
        type: CharacteristicType.Interval,
        label: "Preharvest Abiotic Stress Damage Level",
        categoryId: "vine_abiotic_stress",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Negligible to none",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_abiotic_stress_tol",
        type: CharacteristicType.Interval,
        label: "Preharvest Abiotic Stress Tolerance",
        categoryId: "vine_abiotic_stress",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly susceptible",
                "Susceptible",
                "Moderate",
                "Resistant",
                "Highly resistant"
            ]
        }
    },
    {
        id: "vine_soil_texture_pref",
        type: CharacteristicType.Nominal,
        categoryId: "vine_abiotic_stress",
        label: "Soil Texture Preference",
        params: {
            options: [
                { value: "clay",        label: "Clay soils" },
                { value: "loam",        label: "Loam soils" },
                { value: "sandy_loam",  label: "Sandy-loam soils" },
                { value: "sandy_clay",  label: "Sandy-clay soils" },
                { value: "sandy",       label: "Sandy soils" },
            ]
        }
    },

    //* Vine Productivity Characteristics
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_fruit_set_potent",
        type: CharacteristicType.Interval,
        label: "Fruit-set Potential",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Extremely poor ",
                "Poor",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_fruit_set_date",
        type: CharacteristicType.Event,
        label: "Fruit-set Date",
        categoryId: "vine_productivity",
        params:{
            color: "#b50000",
        }
    },
    {
        id: "vine_precociousness",
        type: CharacteristicType.Interval,
        label: "Precociousness",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very late",
                "Late",
                "Intermediate",
                "Early",
                "Very early"
            ]
        }
    },
    {
        id: "vine_crop_load_potent",
        type: CharacteristicType.Interval,
        label: "Crop-Load Potential",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to low",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    // TODO REFACTOR BI-POLAR
    {
        id: "vine_bear_potent_before",
        type: CharacteristicType.Interval,
        label: "Bearing Potential Before Manipulation",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "None to low",
                "Low",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_bear_potent_after",
        type: CharacteristicType.Interval,
        label: "Bearing Potential After Manipulation",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "None to low",
                "Low",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_production_potent",
        type: CharacteristicType.Interval,
        label: "Production Potential",
        categoryId: "vine_productivity",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to very low",
                "Low",
                "Intermediate",
                "High",
                "Very high "
            ]
        }
    },

    //* Preharvest Adaptability Index
    {
        id: "vine_dormant_release_eff",
        type: CharacteristicType.Interval,
        label: "Dormancy Release Efficiency",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very mild to none",
                "Mild",
                "Intermediate",
                "Pronounced",
                "Severe"
            ]
        }
    },
    {
        id: "vine_flower_intense",
        type: CharacteristicType.Interval,
        label: "Flowering Intensity",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            minDesc: "None",
            descriptors: [
                "Extremely low",
                "Low",
                "Optimal",
            ]
        }
    },
    {
        id: "vine_fruit_set_potent_eff",
        type: CharacteristicType.Interval,
        label: "Fruit Set Potential/Efficiency",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Very brief",
                "Brief",
                "Intermediate",
                "Slightly prolonged",
                "Extended"
            ]
        }
    },
    {
        id: "vine_productivity_potent",
        type: CharacteristicType.Interval,
        label: "Productivity Potential",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Extremely poor",
                "Poor",
                "Intermediate",
                "Good",
                "Excellent"
            ]
        }
    },
    {
        id: "vine_vigour_balance",
        type: CharacteristicType.Interval,
        label: "Vigour Balance",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "None to negligible",
                "Low",
                "Intermediate",
                "High",
                "Very high"
            ]
        }
    },
    {
        id: "vine_disease_psa_resist",
        type: CharacteristicType.Interval,
        label: "Tolerance to Diseases Psa Resistance",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly susceptible",
                "Susceptible",
                "Moderately tolerant",
                "Tolerant",
                "Highly tolerant"
            ]
        }
    },
    {
        id: "vine_preharv_adapt",
        type: CharacteristicType.Interval,
        label: "General Preharvest Adaptability",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Poorly adapted",
                "Partially adapted",
                "Moderately adapted",
                "Highly adapted",
                "Excellent adaptation"
            ]
        }
    },
    {
        id: "vine_frost_tolerance",
        type: CharacteristicType.Interval,
        label: "Frost Tolerance",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly susceptible",
                "Susceptible",
                "Moderately resistant",
                "Resistant",
                "Highly resistant"
            ]
        }
    },
    {
        id: "vine_waterlogging_suscept",
        type: CharacteristicType.Interval,
        label: "Waterlogging Susceptibility",
        categoryId: "vine_adapt_index",
        params: {
            min: 0, max: 100, step: 1,
            descriptors: [
                "Highly susceptible",
                "Susceptible",
                "Moderately resistant",
                "Resistant",
                "Highly resistant"
            ]
        }
    },
]